import {animate, animateChild, group, query, style, transition, trigger} from "@angular/animations";

/**
 * Animations that can be used for transitions between the steps of a chapter.
 */
export const slideInAnimation =
  trigger('routeAnimations', [
    transition(':decrement', [
      style({ position: 'relative' }),
      query(':enter, :leave', [
        style({
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%'
        })
      ]),
      query(':enter', [
        style({ left: '-100%' })
      ]),
      query(':leave', animateChild()),
      group([
        query(':leave', [
          animate('300ms ease-out', style({ left: '100%' }))
        ]),
        query(':enter', [
          animate('300ms ease-out', style({ left: '0%' }))
        ])
      ]),
      query(':enter', animateChild()),
    ]),
    transition(':increment', [
      style({ position: 'relative' }),
      query(':enter, :leave', [
        style({
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%'
        })
      ]),
      query(':enter', [
        style({ left: '100%' })
      ]),
      query(':leave', animateChild()),
      group([
        query(':leave', [
          animate('300ms ease-out', style({ left: '-100%' }))
        ]),
        query(':enter', [
          animate('300ms ease-out', style({ left: '0%' }))
        ])
      ]),
      query(':enter', animateChild()),
    ]),
    transition('void => 1', [
      style({ position: 'relative' }),
      query(':enter, :leave', [
        style({
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%'
        })
      ]),
      query(':enter', [
        style({ opacity: '0' })
      ]),
      group([
        query(':enter', [
          animate('150ms 150ms ease-out', style({ opacity: '1' }))
        ])
      ]),
      query(':enter', animateChild()),
    ]),
    transition('1 => void', [
      style({ position: 'relative' }),
      query(':enter, :leave', [
        style({
          position: 'absolute',
          top: 0,
          left: 0,
          opacity: '1',
          width: '100%'
        })
      ]),
      query(':leave', animateChild()),
      group([
        query(':leave', [
           animate('150ms ease-out', style({ opacity: '0' }))
        ]),
      ]),
    ]),
    transition('void => 99', [
      style({ position: 'relative' }),
      query(':enter, :leave', [
        style({
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%'
        })
      ]),
      query(':enter', [
        style({ opacity: '0' })
      ]),
      group([
        query(':enter', [
          animate('150ms 150ms ease-out', style({ opacity: '1'}))
        ])
      ]),
      query(':enter', animateChild()),
    ]),
    transition('99 => void', [
      style({ position: 'relative' }),
      query(':enter, :leave', [
        style({
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          opacity: '1'
        })
      ]),
      query(':leave', animateChild()),
      group([
        query(':leave', [
          animate('150ms ease-out', style({ opacity: '0' }))
        ]),
      ]),
    ]),
  ]);
